var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(" Please "),_c('a',{staticClass:"text-decoration-none",attrs:{"href":"#"},on:{"click":_vm.myClick}},[_vm._v(" click here ")]),_vm._v(" to verify your email address. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }